import type { ComponentProps, ReactElement } from "react";

import { useDispatch, useSelector } from "react-redux";

import { ResultsSearchRow } from "app/pages/sales-intelligence/common-components/search-results-table";
import advancedSearchFilteringTrackingService from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/tracking";

import { setSearchText } from "../../../store/action-creators";
import { selectActiveLeadsType, selectSearchText } from "../../../store/selectors";

import { SEARCH_PLACEHOLDER_MAP } from "./const";

type Props = Pick<ComponentProps<typeof ResultsSearchRow>, "isDisabled" | "children" | "onSearchClear">;

const SearchRowContainer = ({ isDisabled, children, onSearchClear }: Props): ReactElement => {
    const dispatch = useDispatch();

    const activeLeadsType = useSelector(selectActiveLeadsType);
    const searchText = useSelector(selectSearchText);

    const handleSearch = (text: string): void => {
        if (text.length > 0) {
            advancedSearchFilteringTrackingService.trackSearchFieldUsed(activeLeadsType, text);
        }

        dispatch(setSearchText(text));
    };

    return (
        <ResultsSearchRow
            isDisabled={isDisabled}
            searchText={searchText}
            placeholder={SEARCH_PLACEHOLDER_MAP[activeLeadsType]}
            onSearch={handleSearch}
            onSearchClear={onSearchClear}
        >
            {children}
        </ResultsSearchRow>
    );
};

export default SearchRowContainer;
